import { useQuery, useQueryClient, UseQueryOptions } from "@tanstack/react-query";
import ApiService from "src/util/api.service";
import { QUERY_CONSTANTS } from "./queries.constant";
import { ApiResponse } from "src/types/api.types";
import { User } from "src/types/common.types";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export const useGetQueryState = (name: unknown[]) => {
  const queryClient = useQueryClient();
  return queryClient.getQueryState(name);
};

/**
 * Wraps a useQuery result to provide a refetch that respects an enabled condition.
 */
export const useGeneralRefetchOverride = <T extends { refetch: () => Promise<unknown> }>(
  queryResult: T,
  conditions = true
): T & { refetch: () => Promise<void> } => {
  const refetch = async () => {
    if (conditions) {
      await queryResult.refetch();
    }
  };
  return { ...queryResult, refetch };
};

export const useGetProfile = (
  options?: Omit<UseQueryOptions<ApiResponse<User>>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: [QUERY_CONSTANTS.AUTH.PROFILE],
    queryFn: async () => {
      const response = await ApiService.get<ApiResponse<User>>(
        ServicesUrlEndpoints.USER.PROFILE
      );
      return response.data;
    },
    ...options,
  });
};
